define([], ()=> {
    return ['$q', 'JsonRPCService', ($q, JsonRPCService)=> {
        return {
            autofillBasedOnVIN: (callGroups, vin)=> {
                const deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'lookup', 'lookupBasedOnVIN', [vin], callGroups).then(
                    (vehicleInfo)=> deferred.resolve(vehicleInfo),
                    (error, status, headers) => deferred.reject([error, status, headers]));
                return deferred.promise;
            },
            autofillBasedOnPartialDto(callGroups, dto) {
                const deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'lookup', 'lookupBasedOnPartialDTO', [dto], callGroups).then(
                    vehicleInfo => deferred.resolve(vehicleInfo),
                    (error, status, headers)=> deferred.reject([error, status, headers]));
                return deferred.promise;
            },
            lookupMakes(callGroups) {
                const deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'lookup', 'lookupMakes', [], callGroups).then(
                    (vehicleInfo)=> deferred.resolve(vehicleInfo),
                    (error, status, headers) => deferred.reject([error, status, headers]));
                return deferred.promise;
            },
            aaaVINLookup(callGroups,vinRequestDTO) {
                const deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'aaalookup', 'vinValidation', [vinRequestDTO], callGroups).then(
                (vehicleInfo) => deferred.resolve(vehicleInfo),
                (error, status, headers) => deferred.reject([error, status, headers]));
                return deferred.promise;
            },
             aaaHLDILookup(callGroups, hldiRequestDTO) {
                const deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'aaahldilookup', 'hldiValidation', [hldiRequestDTO], callGroups).then(
                (vehicleInfo)=> deferred.resolve(vehicleInfo),
                (error, status, headers)=> deferred.reject([error, status, headers]));
                return deferred.promise;
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/policyjob/services/VinLookupService.js
 **/